import { render, staticRenderFns } from "./UnassignedStudentsCard.vue?vue&type=template&id=76544208&scoped=true"
import script from "./UnassignedStudentsCard.vue?vue&type=script&lang=js"
export * from "./UnassignedStudentsCard.vue?vue&type=script&lang=js"
import style0 from "./UnassignedStudentsCard.vue?vue&type=style&index=0&id=76544208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76544208",
  null
  
)

export default component.exports